import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';

const app = createApp(App)
    .use(router)
    .mount('#app');

hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('js', javascript);

document.addEventListener('click', (event) => {
    const el = event.target;
    if (el && el.tagName === 'A') {
        const href = el.getAttribute("href");
        const isInternalRoute = !/^(http|#|javascript).*/ig.test(href);
        if (isInternalRoute) {
            event.preventDefault();
            app.$router.push(href);
            window.scrollTo({ top: 0 });
        }
    }
});